<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Recepción no configurada en Costos</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="startCloseModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
						<p class="mb-2">No se ha configurado la Recepción Final en la tabla de costo para el proyecto <b>{{ selectedProject.name }}</b></p>
						<p class="font-weight-bold">¿Quieres a agregarla?</p>
						<div class="d-flex flex-row justify-end">
							<v-btn
								class="mx-2 my-1"
								color="white"
								raised
								@click="startCloseModal"
							>
								<p class="mb-0 text-primary">Cerrar</p>
							</v-btn>
							<v-btn
								class="mx-2 my-1"
								color="#524D4D"
								raised
								dark
								@click="startCloseModal(true)"
							>
								<p class="mb-0">Agregar Recepción Final</p>
							</v-btn>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>

export default {
  name: 'NoReceptionInTableModal',
	props: {
		selectedProject: {
			type: Object,
			required: true
		},
		closeModal: {
			type: Function,
			required: true
		}
	},
  data: () => ({
		indexModal: + new Date(),
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		startCloseModal(add_reception = false){
			this.closeModal(add_reception)
		},
    // closeModal(){
    //   this.$store.commit('budget/setNewBudgetNoteTemplateModal', false)
		// 	this.$store.commit('budget/setNewBudgetNoteTemplateModalEditing', null)
    // },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>